<template>
  <ul class="mainmenu">
    <li>
      <router-link to="/">Home</router-link>
    </li>
    <li class="has-droupdown has-menu-child-item">
      <a href="/product/all">
        All Products
        <Icon name="plus" class="collapse-icon plus"/>
        <Icon name="minus" class="collapse-icon minus"/>
      </a>
      <ul class="submenu" v-if="categories && categories.length === 1">
        <li v-for="category of categories[0].children" :key="category.name">
          <router-link :to="`/product/${category.name}`">{{ category.name }}</router-link>
        </li>
      </ul>
    </li>
    <li class="has-droupdown has-menu-child-item">
      <a>
        Installation Tutorial
        <Icon name="plus" class="collapse-icon plus"/>
        <Icon name="minus" class="collapse-icon minus"/>
      </a>
      <ul class="submenu">
        <li>
          <router-link :to="`/installation/glassSwitch1`">Installation Instruction for Nintendo Switch 2017 / PS Portal</router-link>
        </li>
        <li>
          <router-link :to="`/installation/glassSwitch2`">Installation Instruction for Nintendo Switch OLED / Switch 2</router-link>
        </li>
        <li>
          <router-link :to="`/installation/glassSwitch2-Tray`">Installation Instruction with Application Tray for NS 2</router-link>
        </li>
        <li>
          <router-link :to="`/installation/caseSwitch2`">Installation Instruction for NS 2 Protective Case</router-link>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>
import Icon from "../../icon/Icon";

export default {
  name: 'Nav',
  components: {Icon},
  data() {
    return {
      categories: null
    }
  },
  methods: {
    getData() {
      this.$axios.get('/api/website/categories', {
        params: {
          siteName: 'DayDayUp'
        }
      }).then(res => {
        console.log(res)
        this.categories = res
      });
    }
  },
  mounted() {
    this.getData()
  }
}
</script>